import {SortableData, SortableDataKeys} from "./local-data-sorting.model";

export type SortableFields<K extends keyof SortableData> = SortableData[K]['sortableFields'];

export type SortableDataArray<K extends keyof SortableData> = SortableData[K]['data'][];


export interface SortOrder {
	sortBy: SortableFields<SortableDataKeys> | 'default'
	sortDirection: 'asc' | 'desc'
}

export function sortData<SortableDataKeys extends keyof SortableData>(
	key: SortableDataKeys,
	data: SortableDataArray<SortableDataKeys>,
	sortBy: SortableFields<SortableDataKeys> | 'default', // Added default here instead of having on SortableData so that we won't need to repeat it on every other entries
	sortOrder: 'asc' | 'desc'
): SortableData[SortableDataKeys]['data'][] {
	if (sortBy === 'default') {
		return data;
	}
	return data.sort((a, b) => {
		const valueA = a[sortBy];
		const valueB = b[sortBy];

		if (valueA === valueB) return 0;

		if (sortOrder === 'asc') {
			return valueA > valueB ? 1 : -1;
		} else {
			return valueA < valueB ? 1 : -1;
		}
	});
}
